import React from 'react';

import { IGridCell } from '../../../types/IGridCell';

import LoadingCell from '../loadingCell/loadingCell';

import './textCell.scss';

const TextCell: React.FC<IGridCell> = ({ rowType, dataItem, field, treelist, useTooltip, grid, style, className }) => {
  if (rowType === 'groupHeader') {
    return null;
  }

  if (dataItem[field] === undefined && treelist) return <td style={style} className={className ? className : ''}/>;
  if (dataItem[field] === undefined && grid) return <td style={style} className={className ? className : ''}/>;
  if (dataItem[field] === undefined) return <LoadingCell />;

  return (
    <td style={style} className={className ? className : ''}>
      {field.startsWith('measure') ? (
        <div className='text-cell alignment-right'>{dataItem[field]}</div>
      ) : (
        <div className="text-cell" title={useTooltip ? dataItem[field] : ''}>{dataItem[field]}</div>
      )}
    </td>
  );
};

export default TextCell;
